import Vue from 'vue';
import billTransformer from './../../transformers/bill';
import store from '../../store';

const success = ({ data }, resolve) => {
  const bill = billTransformer.fetch(data);
  store.dispatch('fetchCurrentBill', bill);
  resolve(bill);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/bills/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/show.js